import React, { useState, useRef } from "react";
import { Container, Row, Col, Stack, Image, Card, Form, Button, Overlay} from "react-bootstrap";
import search from "../../../images/search.png";
import notify from '../../../images/notify.png';
import person from "../../../images/person.png";
import arrow from "../../../images/arrow.png";
import logo from '../../../images/logo1.png';
import Typography from '@mui/material/Typography';
import Popover from '@mui/material/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch} from 'react-redux';
import { setStylistLogout, setStylistLogoutUrl, setStylistNotification } from '../../../reducers/User/action';
import Swal from "sweetalert2";
import { postClientNotificationView } from "../../../Service";
import moment from "moment";

const Dashboard = () => {
    const params = useLocation();
    const navigate = useNavigate();
    const dispatch=useDispatch();

    let urlPathName = params.pathname;

    const doLogout = (popupState)=>{
        popupState.close();
        Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to Log Out?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Log Out!'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(setStylistLogout());
                dispatch(setStylistLogoutUrl(urlPathName));
                navigate("/stylistlogin");
            }
        })  
    }
    let loggedUser = useSelector(store => store.user['stylistuser']);
    // let stylistNotification = useSelector(store => store.user.stylistNotification);

    // const notificationOpen = () => {
    //     if ( stylistNotification.count > 0 ) {
    //         postClientNotificationView().then(res => notificationViewResponseHandle(res));
    //     }
    // }

    // const notificationViewResponseHandle = ( res ) => {
    //     let notification = {'count' : 0, 'list' : stylistNotification.list};
    //     dispatch(setStylistNotification(notification));
    // }

    return(
        <div className="top_bar"> 
                <Row>
                    <Col>
                        <Stack direction="horizontal" className="align-items-end" gap={2}>
                            <div className="ms-auto">
                                
                            </div>
                            {/* <div className="d-flex align-items-center">
                                
                                <PopupState variant="popover" popupId="demo-popup-popover">
                                    {(popupState) => {
                                        const handleNotificationClick = (event) => {
                                            notificationOpen();

                                            if (!popupState.isOpen) {
                                                popupState.open(event);
                                            }
                                        };

                                        return (
                                            <div>
                                                <Button
                                                    variant=""
                                                    {...bindTrigger(popupState)}
                                                    className="notoficationBtn"
                                                    onClick={handleNotificationClick}
                                                >
                                                    <Image src={notify} />
                                                    { stylistNotification && stylistNotification.count !== undefined && stylistNotification.count !== 0 && (
                                                        <p className="count">{stylistNotification.count}</p>
                                                    )}
                                                </Button>

                                                <Popover
                                                    {...bindPopover(popupState)}
                                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                                                >
                                                    <Typography component="div" sx={{ p: 2 }}>
                                                        <h3>Notifications</h3>
                                                        <hr />
                                                        {stylistNotification && stylistNotification.list !== undefined && stylistNotification.list.length > 0 ? (
                                                            stylistNotification.list.map((item, index) => (
                                                                <div
                                                                    className="notification-row"
                                                                    key={index}
                                                                >
                                                                    <div className="notification-img-row">
                                                                        <div className="circle"></div>
                                                                        <div className="profile">
                                                                            <Image src={person} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="content">
                                                                        <h5>{item.serviceName}</h5>
                                                                        <p>{item.notificationType}<br></br> on {moment(item.slotDateTime).format("MM-DD-YYYY HH:mm")}</p>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <p>No new notifications</p>
                                                        )}
                                                    </Typography>
                                                </Popover>
                                            </div>
                                        );
                                    }}
                                </PopupState>
                                
                            </div> */}
                            <div className="d-flex align-items-center">
                                
                                <PopupState variant="popover" popupId="demo-popup-popover" >
                                    {(popupState) => (
                                        <div>
                                        <Button variant="" {...bindTrigger(popupState)}>
                                        <div className="pro-sec">
                                        <div className="top-profile"> <Image src={loggedUser ? loggedUser.profileImage ? loggedUser.profileImage : person : person} />
                                        <span className="active circle"></span>
                                        </div>
                                        </div>
                                        </Button>

                                        <Popover
                                            {...bindPopover(popupState)}
                                            anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                            }}
                                            transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center',
                                            }}
                                        >
                                            <Typography component="div" sx={{ p: 2 }}>
                                            <Row className="profile-dropdown">
                                             <Col><Image src={loggedUser ? loggedUser.profileImage ? loggedUser.profileImage : person : person} style={{width : '50px', height : '50px', borderRadius : '50%'}}/> 
                                              
                                             <h4>{loggedUser ? loggedUser.firstName+' '+loggedUser.lastName : ''}</h4>
                                             <h6>{loggedUser ? loggedUser.emailAddress : ''}</h6>
                                             </Col>
                                            </Row> 
                                           
                                            <hr/>
                                            <Row className="profile-link">
                                                <Col>
                                                <div className="text-center"><a onClick={() => doLogout(popupState)} style={{textAlign:'center'}}>Log Out</a></div>
                                               
                                                </Col>
                                            </Row>
                                            
                                            </Typography>
                                        </Popover>
                                        </div>
                                    )}
                                </PopupState>
                                 
                            </div>
                            
                        </Stack>
                    </Col>
                </Row>
 
        </div>
    )
}

export default Dashboard;